import { useEffect, useState } from "react";

/** Debounce adaptativo: curto pra buscas longas, longo pra curtas. */
export function useAdaptiveDebounce(value: string, thresholds: { short: number; long: number } = { short: 250, long: 100 }) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const delay = value.length <= 3 ? thresholds.short : thresholds.long;
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, thresholds.short, thresholds.long]);

  return debounced;
}
